import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import apiService from '../services/api';

const ApiStatusContext = createContext({ isApiOnline: true, checking: false, retry: () => {} });

export function ApiStatusProvider({ children }) {
  const [isApiOnline, setIsApiOnline] = useState(true);
  const [checking, setChecking] = useState(true);

  const checkApi = useCallback(async () => {
    setChecking(true);
    const online = await apiService.checkHealth();
    setIsApiOnline(online);
    setChecking(false);
  }, []);

  useEffect(() => {
    checkApi();
    const interval = setInterval(checkApi, 10000);
    return () => clearInterval(interval);
  }, [checkApi]);

  return (
    <ApiStatusContext.Provider value={{ isApiOnline, checking, retry: checkApi }}>
      {children}
    </ApiStatusContext.Provider>
  );
}

export function useApiStatus() {
  return useContext(ApiStatusContext);
}
